import Swiper from "swiper"
import { Navigation, Pagination, Autoplay } from "swiper/modules"

jQuery(window).on('elementor/frontend/init', (e) => {
  elementorFrontend.hooks.addAction(
    'frontend/element_ready/onereach-case-studies-section.default',
    ($element) => {
      const swiperEl = $element.find('.case-studies-swiper')[0]
      if (!swiperEl) return

      new Swiper(swiperEl, {
        modules: [Navigation, Pagination, Autoplay],
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 18,
        navigation: {
          prevEl: $element.find('.case-studies-swiper__prev')[0],
          nextEl: $element.find('.case-studies-swiper__next')[0],
        },
        pagination: {
          el: $element.find('.case-studies-swiper__pagination')[0],
          type: 'custom',
          renderCustom: (_swiper, current, total) => `${current} - ${total}`,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      })
    }
  )
})